import { DataLayerEvents } from './data-layer-events.js';
import { DataLayerHandler } from './data-layer-handler.js';
import { Events, dispatchViewCartEvent } from '../events.js';
import { getPage, pageReloaded } from '../utilities.js';


/*
* Evento de trafego externo (Links compartilhados em redes sociais)
*/

export const setTraficOriginEvents = () => {
  
  if(getPage() !== "product") return;
      const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get('utm_source') || null;
  const utmMedium = urlParams.get('utm_medium') || null;
  const utmCampaign = urlParams.get('utm_campaign') || null;
  
  const productId = document.querySelector(".produto-code span").textContent.trim();
  const productName = document.querySelector("h1").textContent.trim();

  if(utmSource && utmMedium && utmCampaign && productName && productId){
    DataLayerEvents.traficOrigin(
      { 
        item_id: productId,
        item_name: productName,
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
      }
    );
  }
}
/**
 * Eventos de banner
 */
export const setPromotionEvents = () => {
  document.querySelectorAll("[data-promotionName]")
    ?.forEach(item => {
      const name = item.getAttribute("data-promotionName");
      const id = item.getAttribute("data-promotionId");
      const creativeSlot = item.getAttribute("data-creativeSlot");
      
      let items = null;

      const eventParams = {
        creative_slot: creativeSlot,
        promotion_id: id,
        promotion_name: name,
      }

      if(item.hasAttribute('data-promotionProductId')){
        const productId = item.getAttribute("data-promotionProductId");
        const productName = item.getAttribute("data-promotionProductName");
        items = [{
          item_id: productId,
          item_name: productName,
        }]

        eventParams.items = items
      }

      item.addEventListener("pointerover", () => {
        DataLayerEvents.viewPromotion(eventParams);
      }, { once: true });

      item.addEventListener("click", () => {
        DataLayerEvents.selectPromotion(eventParams);
      }, { once: true });
  });
}

/**
 * Eventos do datalayer relacionados ao product thumb.
 */
export const setProductThumbEvents = () => {
  const thumbs = document.querySelectorAll(".product-thumb");
  const itemList = [];
  thumbs?.forEach(thumb => {
    const productData = DataLayerHandler.getProductData({ element: thumb });
    if (productData) {
      const itemListName = thumb.closest('[data-listName]')?.getAttribute('data-listName')
      const itemIndex = thumb.getAttribute('data-index');
      productData.index = parseInt(itemIndex);
      if (itemListName) productData.item_list_name = itemListName;
      itemList.push(Object.assign({}, productData));
      thumb.addEventListener("click", () => DataLayerEvents.selectItem(productData));
    }
  });
  if (itemList.length > 0) {
    DataLayerEvents.viewItemList(itemList);
  }
}

/**
 * Eventos do data layer que acontecem na página do produto.
 */
export const setProductPageEvents = () => {
  document.addEventListener(Events.ADD_TO_CART, e => {
    const { pid, amount } = e.detail;
    const productData = DataLayerHandler.getProductData({ id: pid });
    productData.quantity = amount;
    const promotionDetails = DataLayerHandler.getPromotionDetails();
    const traficOriginDetais = DataLayerHandler.getTraficOriginDetails();
    DataLayerEvents.addToCart(productData,promotionDetails,traficOriginDetais);
  });
  const product = document.querySelector(".product-info #form-product-buy");
  if (!product) return;
  const productData = DataLayerHandler.getProductData({ element: product });
  if (!productData) return;
  DataLayerEvents.productDetail(productData);
}
/**
 * Eventos do datalayer quando adicionar aos favoritos
 */
export const setWishListEvent = () => {
  const favoriteButtons = document.querySelectorAll(".add-favorites button.btn-favorites");
  if (!favoriteButtons) return;

  const clickHandler = (event) => {
    const button = event.target.type === "button" ? event.target : event.target.closest("button");
    if (!button || button.classList.contains("remove")) return;

    const thumbContainer = button.closest(".product-thumb");
    if (thumbContainer) {
      const productData = DataLayerHandler.getProductData({ element: thumbContainer });
      if (productData) {
        DataLayerEvents.addToWishlist([productData]);
      }
      return;
    }

    const product = document.querySelector(".product-info #form-product-buy");
    if (!product) return;
    const productData = DataLayerHandler.getProductData({ element: product });
    if (!productData) return;
    DataLayerEvents.addToWishlist([productData]);
  } 

  favoriteButtons.forEach(b => b.addEventListener("click", clickHandler, { once: true, capture: true }));
}

/**
 * Eventos do data layer que acontecem no carrinho de compras.
 */
export const setPurchaseListEvents = () => {
  document.addEventListener(Events.REMOVE_FROM_CART, e => {
    if (e.detail.list_id) {
      const listItem = document.querySelector(`#form-purchase-list [data-purchaselist='${e.detail.list_id}']`) 
        ?? document.querySelector(`[data-purchaselist='${e.detail.list_id}']`);
      const productData = DataLayerHandler.getProductData({ element: listItem });
      if (productData) {
        const { price, item_variant, quantity } = DataLayerHandler.getDataFromHtml(listItem);
        productData.item_variant = item_variant;
        productData.price = !isNaN(price) ? parseFloat(price) : parseFloat(productData.price);
        productData.quantity = !isNaN(quantity) ? parseFloat(quantity) : 1;
        DataLayerEvents.removeFromCart(productData);
      }
    }
  });

  document.addEventListener(Events.VIEW_CART, _e => {
    const cartProducts = DataLayerHandler.getProductsDataFromPurchaseList();
    if (cartProducts.length > 0) DataLayerEvents.viewCart(cartProducts);
  });

  if (getPage() === 'purchase-list' && !pageReloaded()) {
    dispatchViewCartEvent();
  }
}

export const setCheckoutEvents = () => {
  if (getPage() !== 'checkout') return;
  const productData = DataLayerHandler.getProductsDataFromPurchaseList();
  if (!productData) return;
  if (!pageReloaded()) {
    const promotionDetails = DataLayerHandler.getPromotionDetails();
    const traficOriginDetais = DataLayerHandler.getTraficOriginDetails();
    DataLayerEvents.beginCheckout(productData,promotionDetails,traficOriginDetais);
  }
  
  document.addEventListener(Events.ADD_SHIPPING_INFO, e => {
    DataLayerEvents.addShippingInfo(productData, e.detail.shipping, e.detail.value);
  });

  document.addEventListener(Events.ADD_PAYMENT_INFO, e => {
    DataLayerEvents.addPaymentInfo(productData, e.detail.paymentName, e.detail.value);
  });

  document.addEventListener("submit", (event) => {
    const form = event.target;
    const formId = form.id;

    if(formId == 'form-person-insert' ||formId == 'form-company-insert'){
      const formData = new FormData(form);
      const infos = Object.fromEntries([...formData].filter(([key]) => ["reciveNews", "email[]", "full_name"].includes(key)).map(([key, value]) => [key === "email[]" ? "person_email" : key === "full_name" ? "person_name" : key, value]));
    
      if(infos["reciveNews"] && infos["reciveNews"] == 'on'){
        delete infos["reciveNews"];
        DataLayerEvents.reciveNews(infos)
      }
    }
    
});

}

/**
 * Evento de compra sucedida.
 */
export const setPurchaseEvent = () => {
  if (getPage() !== 'purchase-order') return;

  const productsData = DataLayerHandler.getProductsDataFromPurchaseList();
  const tracked = document.querySelector('[data-tracked]')?.getAttribute('data-tracked') == 1;
  const traficOriginDetais = DataLayerHandler.getTraficOriginDetails();
  if (!productsData || tracked) return;
  
  const reciveNews = sessionStorage.getItem("reciveNews");
  if(reciveNews){
    DataLayerEvents.reciveNews(DataLayerHandler.getPersonDetails())
  }
  
  DataLayerEvents.purchase(productsData, DataLayerHandler.getPurchaseDetails(),traficOriginDetais);
  DataLayerHandler.updateTracked();
}